module.exports = __webpack_public_path__ + "img/boletines.ed60aea4.jpg";